import { OpenSuggestionPanelProvider } from 'components/suggestion-context/context/openSuggestionPanelContext'
import { SuggestionContextProvider } from './context/suggestionsContext'
import Suggestions from './suggestions'

export default () => (
  <SuggestionContextProvider>
    <OpenSuggestionPanelProvider>
      <Suggestions />
    </OpenSuggestionPanelProvider>
  </SuggestionContextProvider>
)
